//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/GeometricUtilities.js";
import "../no/Routing.js";
let d=[[[1,"ArcLength",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"CreateTangencySetting",1,0],[1,"EndPercentage",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"NumberOfSegments",1,0],[0,"ReverseDirection",1,0],[1,"SelectedSegment",0,"Routing.RouteObjectCollector",0],[1,"StartPercentage",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"SubdivideAtPoint",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"Type",1,0]],[[["numSubdividedCurves"],"GetSubdividedCurves",{R_:{subdividedCurves:"Curve[]"}},0,0]],[]];
SPLM.RoutingCommon.SubdivideCurveBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.RoutingCommon.SubdivideCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.RoutingCommon.SubdivideCurveBuilder.Types = Object.freeze({
    "AtPoint" : "AtPoint", "EqualSegments" : "EqualSegments", "ArcLengthSegments" : "ArcLengthSegments"});

export default SPLM;